import React from "react";

/**
 * TeaserGrid — responsive auto-fit grid for FeatureCard / SampleCard rows.
 * Wraps naturally and never causes horizontal body scroll.
 *
 * Props:
 *   minColWidth?  number  min card width in px before wrapping (default 240)
 *   gap?          number  grid gap in px (default 20)
 *   className?    str
 *   children      node
 */
const TeaserGrid = ({ minColWidth = 240, gap = 20, className = "", children }) => {
  return (
    <div
      className={"teaser-grid" + (className ? ` ${className}` : "")}
      style={{
        gridTemplateColumns: `repeat(auto-fit, minmax(min(${minColWidth}px, 100%), 1fr))`,
        gap: `${gap}px`,
      }}
    >
      {children}
    </div>
  );
};

export default TeaserGrid;
